/**
 * Classe responsável pelas ações do grid para o servicetime updates
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 08/08/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.Grid = function () {

    var entity = "ServiceTimeUpdates";

    var calculatePercent = function (current, suggest) {

        var percent = 0;

        percent = (suggest - current) / current * 100;
        percent = parseInt(percent, 10);

        return percent;

    };

    var addActionsToGrid = function () {

        var error = null;

        try {

            var acceptAll = new Greenmile.ServiceTimeUpdates.AcceptAll();
            var acceptSelected = new Greenmile.ServiceTimeUpdates.AcceptSelected(this.getParams());
            var rejectAll = new Greenmile.ServiceTimeUpdates.RejectAll();
            var rejectSelected = new Greenmile.ServiceTimeUpdates.RejectSelected(this.getParams());

            acceptAll.initialize(this.entity);
            acceptSelected.initialize(this.entity);
            rejectAll.initialize(this.entity);
            rejectSelected.initialize(this.entity);

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add actions to grid", e);
            error.console();

        }

    }.bind(this);

    var checkColumn = function () {

        var error        = null,
            obj          = null,
            eventOnclick = "new Greenmile.ServiceTimeUpdates.GridEventsListener().checkItem(this);";

        try {

            obj = {
                id: "checkColumn",
                name: "<input type='checkbox' class='checkAll'/>",
                field: "inputCheck",
                width: 30,
                cssClass: "cell-row check",
                sortable: false,
                resizable: false,
                fieldId: "accept",
                formatter: function (row, cell, value, columnDef, dataContext) {

                    var input = document.createElement("input");
                    var grid = App.Forms.ServiceTimeUpdates.table;

                    input.type = "checkbox";

                    if (Monet.Session.ServiceTimeUpdates.allChecked) {

                        grid.setSelectedRow(row);
                        input.setAttribute("checked", "checked");

                    } else {

                        if (grid.rowsSelected.indexOf(row) !== -1) {
                            input.setAttribute("checked", "checked");
                        }

                    }

                    input.setAttribute("onClick", eventOnclick);
                    input.setAttribute("identity", dataContext.idOfObject);
                    input.setAttribute("row", row);

                    return input.outerHTML;
                }

            };

            return obj;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on add actions to grid");
            error.console();
        }


    };

    var columnCustom = function (action) {

        var error = null;
        var obj                  = {},
            i18n                 = Monet.I18n,
            eventOnclickAccepted = "new Greenmile.ServiceTimeUpdates.GridEventsListener().acceptItem(this);",
            eventOnclickRejected = "new Greenmile.ServiceTimeUpdates.GridEventsListener().rejectItem(this);";

        try {

            obj = {
                id: action,
                name: "",
                field: "input" + action,
                width: 70,
                cssClass: "cell-row " + action,
                sortable: false,
                resizable: false,
                fieldId: action,
                formatter: function (row, cell, value, columnDef, dataContext) {

                    var button = document.createElement("input");
                    button.setAttribute("type", "button");
                    button.setAttribute("identity", dataContext.idOfObject);
                    button.setAttribute("row", row);

                    if (action === "accept") {

                        button.value = i18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.btnAccept");
                        button.setAttribute("onClick", eventOnclickAccepted);

                    } else {

                        button.value = i18n.getResourcesByKey("Greenmile.ServiceTimeUpdates.btnReject");
                        button.setAttribute("onclick", eventOnclickRejected);

                    }

                    return button.outerHTML;

                }

            };

            return obj;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add actions to grid");
            error.console();

        }

    };

    var formatToLink = function (value, id, fieldName ) {

        var error        = null,
            link         = null,
            eventOnClick = `window.location.href = "#/Location/edit/${id}"`;

        if(fieldName === 'serviceTimeType') {
            eventOnClick = `window.location.href = "#/ServiceTimeType/edit/${id}"`;
        }

        try {

            link = document.createElement("a");
            link.setAttribute("identity", id);
            link.setAttribute("onClick", eventOnClick);
            link.style.cursor = "pointer";
            link.innerHTML = value;

            return link.outerHTML;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error format to link.");
            error.console();

        }

    };

    var formatValues = function (row, cell, value, columnDef, dataContext) {

        var error           = null,
            column          = null,
            fieldName       = '',
            model           = null,
            timecurrentFix  = "",
            timeCurrentVar  = "",
            timeUserFix     = "",
            timeUserVar     = "",
            columnIsInteger = false,
            columnIsDecimal = false,
            fieldsToSeconds = ["currentFixTimeSecs",
                "currentVarTimeSecs",
                "sugFixTimeSecs",
                "sugVarTimeSecs",
                "currentAvgServiceTimeSec"];

        try {

            model = dataContext.model.attributes;
            fieldName = (model.location? 'location.id' : 'serviceTimeType');
            timeUserFix = model.userFixTimeSecs;
            timeUserVar = model.userVarTimeSecs;
            timeCurrentVar = dataContext.currentVarTimeSecs;
            timecurrentFix = dataContext.currentFixTimeSecs;
            column = columnDef;

            var getValuePercentFields = function(current, suggest) {
                var valueToReturn = '';
                if (current && suggest) {

                    valueToReturn = calculatePercent(current, suggest);

                    if (isNaN(valueToReturn)) {
                        valueToReturn = "";
                    } else {
                        valueToReturn += ' '+ Monet.I18n.getResourcesByKey("Greenmile.symbol.percent");
                    }

                } else {

                    if (value !== "") {
                        valueToReturn = value + ' '+Monet.I18n.getResourcesByKey("Greenmile.symbol.percent");
                    }
                }

                return valueToReturn;
            };

            if (typeof value !== 'undefined' || value === null) {

                if (fieldsToSeconds.indexOf(column.field) !== -1) {

                    if (column.field === "sugFixTimeSecs" && timeUserFix) {
                        value = timeUserFix;
                    }

                    if (column.field === "sugVarTimeSecs" && timeUserVar) {
                        value = timeUserVar;
                    }

                    var formatter = new Monet.Format.SECONDS(value);
                    value = formatter.convertSecondsToHourMinutesSeconds().getValue();

                } else if (column.field === "calculatedVariableRatePercetage") {

                     value = getValuePercentFields(timeCurrentVar, timeUserVar);

                } else if (column.field === "calculatedFixedRatePercetage") {

                    value = getValuePercentFields(timecurrentFix, timeUserFix);

                } else if (column.field.indexOf(".key") !== -1) {

                    fieldName = fieldName.split('.')[0];
                    var id = (model[fieldName] ? model[fieldName].id: model.id);
                    value = formatToLink(value, id, fieldName);

                } else if (column.fieldInformation.type === "CHECKBOX") {

                    value = Monet.Grid.Utils.formatBooleanValue(value);

                }

                columnIsInteger = column.fieldInformation.type === "INTEGER";
                columnIsDecimal = column.fieldInformation.type === "DECIMAL";

                if (columnIsInteger || columnIsDecimal) {

                    value = "<span class='numberOnGrid'>" + value + "</span>";

                }

            } else {
                value = "";
            }


            return value;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on format values.", e);
            error.console();

        }

    };

    this.getArrayNotSortableColumns = function() {
        return ["calculatedFixedRatePercetage",
            "calculatedVariableRatePercetage",
            "deliveriesAccepted",
            "deliveriesRejected",
            "currentAvgPlannedSize1",
            "currentAvgPlannedSize2",
            "currentAvgPlannedSize3",
            "used"];
    };

    this.getColumns = function () {

        var error              = null,
            name               = "",
            columns            = [],
            sectionRelatedList = null,
            pageLayout         = null,
            arrayNotSortable   = this.getArrayNotSortableColumns();

        try {

            pageLayout = App.Forms.ServiceTimeUpdates.layout.index;

            sectionRelatedList = pageLayout.sections[0].sectionRelatedLists;

            $.each(sectionRelatedList, function (index, grid) {

                $.each(grid.searchGridLayout.searchGridColumns, function (index, column) {

                    var sortable        = true,
                        setNameOfColumn = null;

                    if (column.field.lookupEntityColumn) {

                        name = column.field.name + "." + column.field.lookupEntityColumn;

                    } else {

                        name = column.field.name;

                    }

                    if (arrayNotSortable.indexOf(name) !== -1) {
                        sortable = false;
                    }

                    setNameOfColumn = function () {

                        var error          = null,
                            label          = "",
                            isSize1Alias   = false,
                            isSize2Alias   = false,
                            isSize3Alias   = false,
                            nameFormatted  = "",
                            configurations = Monet.Session.Configurations;

                        try {

                            label = column.field.label;

                            nameFormatted = Monet.I18n.getResourcesByKey(label);
                            isSize1Alias = nameFormatted.indexOf("{size1Alias}") !== -1;
                            isSize2Alias = nameFormatted.indexOf("{size2Alias}") !== -1;
                            isSize3Alias = nameFormatted.indexOf("{size3Alias}") !== -1;

                            if (isSize1Alias) {

                                nameFormatted = nameFormatted.replace("{size1Alias}", configurations.size1Alias);

                            } else if (isSize2Alias) {

                                nameFormatted = nameFormatted.replace("{size2Alias}", configurations.size2Alias);

                            } else if (isSize3Alias) {

                                nameFormatted = nameFormatted.replace("{size3Alias}", configurations.size3Alias);

                            }

                            return nameFormatted;

                        } catch (e) {

                            error = new Monet.Exception.ReturnError(
                                this, "Error on set name of column.");
                            error.console();

                        }

                    };


                    var obj = {
                        id: column.field.id,
                        name: setNameOfColumn(),
                        field: name,
                        width: column.sizePixels,
                        cssClass: "cell-row",
                        sortable: sortable,
                        resizable: true,
                        fieldId: column.field.id,
                        fieldInformation: column.field,
                        formatter: formatValues
                    };

                    if (name === "sugFixTimeSecs" || name === "sugVarTimeSecs") {
                        obj.editor = Greenmile.Grid.Editor.TimePicker;
                    }

                    columns.push(obj);

                });

            });

            columns.unshift(checkColumn());
            columns.splice(1, 0, columnCustom("accept"));
            columns.splice(2, 0, columnCustom("reject"));

            return columns;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on get columns.", e);
            error.console();

        }

    };

    this.show = function () {

        var error              = null,
            options            = {
                entity: entity,
                columnCheckBox: {
                    show: false,
                    checkBoxEventClass: [Greenmile.ServiceTimeUpdates.AcceptAll,
                        Greenmile.ServiceTimeUpdates.RejectAll
                    ],
                    options: {
                        checkOnClickRow: false
                    }
                },
                columnEdit: {
                    show: false
                },
                frozenColumn: 2,
                actions: ["CUSTOM_FILTERS", "SAVE_LAYOUT", "CUSTOMIZE_COLUMNS", "EXPORT_FORMATS"],
                fieldsOverride: { MILLISECONDS: 'SECONDS' },
                multiColumnSort: true,
                editable: true,
                autoEdit: true,
                rowHeight: 40,
                gridContainner: '#' + entity + ' #grid'
            },
            containner         = '#' + entity + ' #grid',
            columns            = [],
            dataView           = null,
            grid               = null,
            pageLayout         = null,
            sectionRelatedList = null;

        try {

            columns = this.getColumns();

            pageLayout = App.Forms.ServiceTimeUpdates.layout.index;

            sectionRelatedList = pageLayout.sections[0].sectionRelatedLists;

            dataView = new Monet.Grid.DataProvider(columns, null, entity);

            grid = new Monet.Grid.GenericGrid(containner, dataView, columns, options);

            let exportFormats = App.Forms.ServiceTimeUpdates.actions.exportFormats;
            exportFormats.setEntityToRequest(this.entityToRequest);
            exportFormats.setDataToRequest({
                and: [
                    { "attr": "session.id", "eq": Monet.Session.ServiceTimeUpdates.session.id },
                    { "attr": "accepted", "isNull": true }
                ]
            });

            let defaultFilter = { 'location.description': {value: ''}};
            if(this.entity !== "ServiceTimeUpdatesServiceTimeType") {
                defaultFilter = { 'serviceTimeType.description': {value: ''}}
            }

            App.Forms.ServiceTimeUpdates.filterBuilder.setIdScreen(entity);
            App.Forms.ServiceTimeUpdates.filterBuilder.setDefaultFilters(defaultFilter);
            App.Forms.ServiceTimeUpdates.filterBuilder.adjustHeaderSize();
            App.Forms.ServiceTimeUpdates.filterBuilder.customRequest = App.Objects.ServiceTimeUpdates.getPendingSession.bind(App.Objects.ServiceTimeUpdates);

            grid.rowsSelected = [];

            grid.onCellChange.subscribe(function (e, args) {

                var error    = null,
                    columns  = [],
                    property = null,
                    item     = null,
                    value    = {},
                    id       = null,
                    field    = null;

                try {


                    columns = args.grid.getColumns();
                    field = columns[args.cell].field;

                    if (field === "sugVarTimeSecs") {

                        item = args.item[field];
                        property = "userVarTimeSecs";

                    } else if (field === "sugFixTimeSecs") {

                        item = args.item[field];
                        property = "userFixTimeSecs";

                    }

                    id = args.item.idOfObject;

                    value[property] = item;

                    App.Objects.ServiceTimeUpdates.updateServiceTimeUpdate(value, id);

                } catch (msg) {

                    error = new Monet.Exception.ReturnError(this,
                        "Error on cell change service time updates.");
                    error.console();

                }

            });

            grid.setSelectedRow = function (row) {

                var _row = parseInt(row, 10);

                if (this.rowsSelected.indexOf(_row) === -1) {
                    this.rowsSelected.push(_row);
                }

            };

            grid.removeSelectedRow = function (row) {

                var _row = parseInt(row, 10);
                var index = this.rowsSelected.indexOf(_row);

                this.rowsSelected.splice(index, 1);

            };

            grid.getSelectedRows = function () {
                return this.rowsSelected;
            };

            grid.clearSelectedRows = function () {
                this.rowsSelected = [];
            };

            grid.removeDataByRowsAndReceiveRemainingData = function (rows) {

                var error          = null,
                    data           = [],
                    rowsLength     = 0,
                    arrayDataItems = [];

                try {

                    rowsLength = rows.length;

                    if (rowsLength > 0) {

                        data = App.Forms.ServiceTimeUpdates.dataProvider;

                        for (var i = 0; i < rowsLength; i++) {

                            var dataItem = grid.getDataItem(rows[i]);
                            arrayDataItems.push(dataItem.id);

                        }

                        for (var j = 0; j < arrayDataItems.length; j++) {

                            data.deleteItemById(arrayDataItems[j]);

                        }

                    }

                    return data.data;

                } catch (e) {
                    error = new Monet.Exception.ReturnError(this, "Error on remove data by rows;");
                    error.console();
                }
            };

            grid.checkAllOnListenner = function () {

                var eventListener = new Greenmile.ServiceTimeUpdates.GridEventsListener(),
                    allChecked    = false,
                    data          = [],
                    selecteds     = [];

                data = grid.getData().data;
                selecteds = grid.getSelectedRows();

                if (selecteds.length === data.length) {
                    allChecked = true;
                }

                eventListener.checkOrUncheckCheckboxColumnHeader(allChecked);

            };

            var inputHeader = new Greenmile.ServiceTimeUpdates.GridEventsListener();
            inputHeader.headerElementListener();

            addActionsToGrid();

            App.Forms[entity].table = grid;
            App.Forms[entity].dataProvider = dataView;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on show grid.", e);
            error.console();

        }

    };

    this.updateGrid = function (filter, callback, appendCollection, validateEndSession) {

        var error                      = null,
            collection = null,
            projection                 = null,
            tableLayout                = null,
            that                       = this,
            addScroll                  = true,
            isAppendCollection         = false;

        try {

            collection = new this.collection();
            projection = this.getProjectionBasedOnIndex();

            isAppendCollection = typeof appendCollection !== "undefined" && appendCollection === true;

            if (!isAppendCollection) {
                collection.reset();
            }

            tableLayout = App.Forms.ServiceTimeUpdates.dataProvider.columns;

            collection.filterWithRestrictions({
                url: this.entityToRequest,
                criteria: projection,
                filter: filter,
                success: function (result) {
                    if(result.size() === 0 && App.Forms['ServiceTimeUpdates'].pagination) {
                        App.Forms['ServiceTimeUpdates'].pagination.canIncrement = false;
                    }

                    if (validateEndSession && result.size() === 0) {
                        const hasSelectedFilter = App.Forms.ServiceTimeUpdates.filterBuilder.getCriteriaChain().criteriaChain[0].and.length;

                        if(!hasSelectedFilter) {
                            App.Objects.ServiceTimeUpdates.endSession(
                                "Greenmile.ServiceTimeUpdates.noLocationsForSession", true
                            );
                        } else {

                            const yesCallback = () => { App.Objects.ServiceTimeUpdates.endSession("", false) }  ;
                            const noCallback = () => {
                                App.Views.ServiceTimeUpdates.modal.closeModalWindow();
                                App.Forms.ServiceTimeUpdates.filterBuilder.adjustHeaderSize();
                            };

                            App.Views.ServiceTimeUpdates.askIfUserWantsEndSession('Greenmile.ServiceTimeUpdates.NoDataAskEndSession', yesCallback, noCallback);
                        }
                    }

                    if (callback) {
                        callback('ServiceTimeUpdates', tableLayout, result, addScroll);
                        App.Forms.ServiceTimeUpdates.filterBuilder.adjustHeaderSize();
                    }

                    $("#" + that.entity + " .MonetUILoadingData").hide();
                }
            });

        } catch (e) {
            error = new Monet.Exception.Return(this,
                "Error on update grid", e);
            error.console();
        }

    };

    this.getProjectionBasedOnIndex = () => {
        var entity = 'ServiceTimeUpdates';
        var pageLayout = App.Forms[entity].layout.index;

        var projectionBuilder = new Monet.Builder.Projection();
        projectionBuilder.setLayout(pageLayout);
        projectionBuilder.addFieldTransient('calculatedFixedRatePercetage');
        projectionBuilder.addFieldTransient('calculatedVariableRatePercetage');
        projectionBuilder.parseLayout();

        projectionBuilder.setPagination(App.Forms[entity].pagination);

        return projectionBuilder.projection.toString();
    };

};
